import { useState, useEffect } from "react";
import { Popover, Divider, Stack } from "@mantine/core";
import { HiTableCells, HiChevronDown } from "react-icons/hi2";
import CustomButton from "../CustomButton/CustomButton";
import CustomCheckBox from "../CustomCheckBox/CustomCheckBox";
import { CustomText } from "../CustomText/CustomText";

export default function ColumnVisibilitySelector({
  columns = [],
  defaultColumnKeys = [],
  visibleColumnKeys = [],
  onChange,
  label = "Apply Column",
  buttonProps = {},
}) {
  const [opened, setOpened] = useState(false);
  const [stagedKeys, setStagedKeys] = useState(visibleColumnKeys);

  useEffect(() => {
    if (opened) {
      setStagedKeys(visibleColumnKeys);
    }
  }, [opened, visibleColumnKeys]);

  const defaultColumns = columns.filter((col) =>
    defaultColumnKeys.includes(col.key),
  );
  const optionalColumns = columns.filter(
    (col) => !defaultColumnKeys.includes(col.key),
  );

  const handleToggle = (key) => {
    setStagedKeys((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key],
    );
  };

  const handleApply = () => {
    onChange?.(stagedKeys);
    setOpened(false);
  };

  return (
    <Popover
      opened={opened}
      onChange={setOpened}
      position="bottom-start"
      shadow="md"
      radius="md"
      width={220}
    >
      <Popover.Target>
        <CustomButton
          variant="light"
          color="primary"
          size="sm"
          radius="md"
          leftSection={<HiTableCells size={16} />}
          rightSection={<HiChevronDown size={16} />}
          onClick={() => setOpened((o) => !o)}
          {...buttonProps}
        >
          {label}
        </CustomButton>
      </Popover.Target>

      <Popover.Dropdown>
        <Stack gap="xs">
          <CustomText size="xs" fw={600} c="dimmed">
            Default
          </CustomText>
          {defaultColumns.map((col) => (
            <CustomCheckBox
              key={col.key}
              label={col.label}
              checked
              disabled
              styles={{
                label: { color: "var(--mantine-color-gray-5)" },
              }}
            />
          ))}

          {optionalColumns.length > 0 && (
            <>
              <Divider />
              <CustomText size="xs" fw={600} c="dimmed">
                Optional
              </CustomText>
              {optionalColumns.map((col) => (
                <CustomCheckBox
                  key={col.key}
                  label={col.label}
                  checked={stagedKeys.includes(col.key)}
                  onChange={() => handleToggle(col.key)}
                />
              ))}
            </>
          )}

          <Divider />
          <CustomButton
            size="xs"
            radius="md"
            color="primary"
            fullWidth
            onClick={handleApply}
          >
            Apply
          </CustomButton>
        </Stack>
      </Popover.Dropdown>
    </Popover>
  );
}
